import React from "react";
import { BrowserRouter } from "react-router-dom";

const EmployeesProfile = () => {
  return <BrowserRouter>EmployeesProfile</BrowserRouter>;
};

export default EmployeesProfile;
